import { lazy } from "react"
import { useTranslation } from "react-i18next"

import { RegionWrapper } from "@/components/layout/Region"
import { Loader } from "@/components/Loader"

const RfqsCore = lazy(() => import("./RfqsCore"))

const LoaderComponent = () => {
  const { t } = useTranslation()
  return (
    <Loader
      ariaLabel={t("credit.loadingCreditRFQTiles")}
      minWidth="22rem"
      minHeight="22rem"
    />
  )
}

export const Rfqs = () => (
  <RegionWrapper fallback={<LoaderComponent />}>
    <RfqsCore>
      <LoaderComponent />
    </RfqsCore>
  </RegionWrapper>
)

export default Rfqs
